import React, { Component } from 'react';
import { Utils } from '../../../services';
import './card-body.css';

class GeckoCardBody extends Component {

	prepareClasses() {
		return Utils.classNames({
			'padded': this.props.padded,
			'padded-vertical': this.props.paddedV,
			'padded-horizontal': this.props.paddedH
		});
	}

	renderClasses() {
		return `body gecko-card-body ${this.prepareClasses()}`;
	}

    render() {
		return (
            <div className={this.renderClasses()}>
                {this.props.children}
            </div>
        );
    }
}

export default GeckoCardBody;